import React from "react";
import { Modal, Spin } from "antd";
import SubscribeForm from "../components-reusable/SubscribeForm";
import { useData } from "../contexts/DataContext";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

interface SubscribeFormProps {
  visible: boolean;
  onClose: () => void;
}

const SubscribeFormDialog: React.FC<SubscribeFormProps> = ({
  visible,
  onClose,
}) => {
  const { state } = useData();
  return (
    <Modal
      open={visible}
      onOk={onClose}
      onCancel={onClose}
      style={{ padding: "0 20px" }}
      footer={null}
    >
      {state.subscribePage && (
        <h1 style={{textAlign:"center"}}>{state.subscribePage.Title}</h1>
      )}
      <div style={{ display: "flex", marginTop: "25px", marginBottom: "20px" }}>
        <div style={{ flex: 1, alignContent: "center", paddingRight:"10px" }}>
          <img
            style={{ height: "250px", width: "auto" }}
            src={
              state.subscribePage
                ? `${state.baseApiPath}${state.subscribePage?.Image.formats.medium.url}`
                : ""
            }
            alt="Subscribe"
          />
        </div>
        <div style={{ width: "200px" }}>
          {state.subscribePage ? (
            <div>
              <BlocksRenderer
                content={state.subscribePage.Text}
              ></BlocksRenderer>
            </div>
          ) : (
            <Spin></Spin>
          )}
        </div>
      </div>
      <SubscribeForm caller={"form"} />
    </Modal>
  );
};

export default SubscribeFormDialog;
